import gql from 'graphql-tag';

export const FeedFollowRecommendationMutation = gql`
	mutation FeedFollowRecommendationMutation(
		$followUser: [ID]
		$followSpace: [Long]
		$unfollowUser: [ID]
		$unfollowSpace: [Long]
	) {
		setFeedUserConfig(
			input: {
				followUsers: $followUser
				followSpaces: $followSpace
				unfollowUsers: $unfollowUser
				unfollowSpaces: $unfollowSpace
			}
		) {
			success
		}
	}
`;
